import { useHubble } from '@seek/hubble';
import { useCallback } from 'react';

import { useDeleteProfileAvatarMutation } from 'src/components/Profile/Avatar/data';
import { useAppConfig } from 'src/modules/appConfig';

interface UseDeleteAvatarOptions {
  onClose: () => void;
}

export const useDeleteAvatar = ({ onClose }: UseDeleteAvatarOptions) => {
  const hubble = useHubble();
  const { zone, language } = useAppConfig();

  const onCompleted = useCallback(() => {
    hubble.trackEvent('profile_update_succeeded', {
      updateSection: 'profile avatar',
      updateType: 'remove',
      updateValues: [],
      displayLanguage: language,
      zone,
    });
    onClose();
  }, [onClose, hubble, language, zone]);

  const onError = useCallback(() => {
    onClose();
  }, [onClose]);

  const [deleteProfileAvatarMutation, { loading: deleteProfileAvatarLoading }] =
    useDeleteProfileAvatarMutation({
      onCompleted,
      onError,
    });

  const handleDelete = useCallback(() => {
    deleteProfileAvatarMutation({});
  }, [deleteProfileAvatarMutation]);

  return {
    handleDelete,
    isDeleting: deleteProfileAvatarLoading,
  };
};
